import React from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import NoCondoResutls from '@assets/images/no_condos_results.png';

import './style.scss';

function CondoWeeksEmptyComponent() {
  return (
    <div className="condo-results-empty">
      <img className="no-result weeks" src={NoCondoResutls} alt="" />

      <h3><FormattedMessage id="no.result.oops" /></h3>

      <h4><FormattedMessage id="no.available.unit" /></h4>
    </div>);
}

const ApplicationComponentWithRouter = withRouter(CondoWeeksEmptyComponent);

export const CondoWeeksEmpty = connect()(ApplicationComponentWithRouter);
